import { render, staticRenderFns } from "./MFAForm.vue?vue&type=template&id=5f652ba3&"
import script from "./MFAForm.vue?vue&type=script&lang=js&"
export * from "./MFAForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports